import { ButtonCoreProps, ButtonTypes, ButtonFontSizes } from "./types"
import React, { useCallback } from "react"
import { Loading } from "~widgets/loading"
import styled from '~/ui/styled'

const ButtonWrap = styled.TouchableOpacity<{ type: ButtonTypes; disabled: boolean; color: string }>`
  flex-direction: row;
  justify-content: center;
  padding: ${({ type }) => {
    if (type === "text") return "0px"
    else {
      return "10px 30px"
    }
  }};
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
  border-color: ${({ theme, type, disabled, color }) => {
    if (type === "solid") {
      if (disabled) return theme.colors.border
      return color || theme.colors.primary
    } else if (type === "outline") {
      if (disabled) return theme.colors.border
      return color || theme.colors.primary
    } else if (type === "text") {
      return "transparent"
    } else {
      return "red"
    }
  }};
  background-color: ${({ theme, type, disabled, color }) => {
    if (type === "solid") {
      if (disabled) return theme.colors.border
      return color || theme.colors.primary
    } else if (type === "outline") {
      return "transparent"
    } else if (type === "text") {
      return "transparent"
    } else {
      return "red"
    }
  }};
`

const ButtonText = styled.Text<{
  type: ButtonTypes
  disabled: boolean
  color: string
  fontSize: ButtonFontSizes
}>`
  color: ${({ theme, type, disabled, color }) => {
    if (disabled) {
      return theme.colors.secondaryText
    } else if (type === "solid") {
      return theme.colors.blockBackground
    } else if (type === "outline") {
      return color || theme.colors.primary
    } else if (type === "text") {
      return color || theme.colors.text
    } else {
      return "red"
    }
  }};
  font-size: ${({ fontSize }) => {
    const sizeMap = {
      l: "16px",
      s: "14px",
      xs: "12px",
    }
    return fontSize ? sizeMap[fontSize] : sizeMap[ButtonFontSizes.L]
  }}; ;
`

export const ButtonCore: React.FC<ButtonCoreProps> = ({
  type,
  text,
  disabled,
  loading,
  onClick,
  color,
  fontSize,
}) => {
  const handleOnPress = useCallback(async () => {
    if (disabled || loading) return
    onClick && (await onClick())
  }, [disabled, onClick])

  return (
    <ButtonWrap type={type} onClick={handleOnPress} disabled={disabled} color={color}>
      {loading ? (
        <Loading />
      ) : (
        <ButtonText type={type} disabled={disabled} color={color} fontSize={fontSize}>
          {text}
        </ButtonText>
      )}
    </ButtonWrap>
  )
}
